import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './Header';
import Main from './Main';
import Footer from './Footer';
import Contact from './Contact';
import ThankYou from './ThankYou';
import Poznamky from './Poznamky';
import Povinnosti from './Povinnosti';
import Personalistika from './Personalistika';
import AdminLogin from './AdminLogin';
import EmployeeLogin from './EmployeeLogin';
import Kalkulacka from './Kalkulacka';
import EvidenciaPrace from './EvidenciaPrace';
import InvoicePreview from './InvoicePreview';
import { EvidenciaPraceProvider } from './context/EvidenciaPraceContext';
import EvidenciaMechanizmov from './mechanizmy/EvidenciaMechanizmov';
import KnihaJazd from './KnihaJazd';
// ...existing code...


function App() {
  return (
    <EvidenciaPraceProvider>
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/thankyou" element={<ThankYou />} />
          <Route path="/poznamky" element={<Poznamky />} />
          <Route path="/povinnosti" element={<Povinnosti />} />
          <Route path="/personalistika" element={<Personalistika />} />
          <Route path="/personalistika/admin-login" element={<AdminLogin />} />
          <Route path="/personalistika/employee-login" element={<EmployeeLogin />} />
          <Route path="/kalkulacka" element={<Kalkulacka />} />
          <Route path="/evidencia-prace" element={<EvidenciaPrace />} />
          <Route path="/invoice-preview" element={<InvoicePreview />} />
          <Route path="/mechanizmy" element={<EvidenciaMechanizmov />} />
          {/* ...existing code... */}
          <Route path="/kniha-jazd" element={<KnihaJazd />} />
        </Routes>
        <Footer />
      </Router>
    </EvidenciaPraceProvider>
  );
}

export default App;